"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotDollar = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotDollar = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M20 1.667v36.667m8.333-30.001h-12.5a5.833 5.833 0 0 0 0 11.666h8.334a5.833 5.833 0 0 1 0 11.667H10"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotDollar = SpotDollar;
SpotDollar.displayName = "SpotDollar";